<script lang="ts">
	import type { SvelteComponent } from "svelte";
	import type { ICard, ICardMeta, ICardShape } from "@xbs/lib-kanban";

	export let cardFields: ICard;
	export let dragging = false;
	export let selected = false;

	export let cardShape: ICardShape;
	export let cardTemplate: SvelteComponent;
	export let meta: ICardMeta = null;
	export let cardHeight: number | null;

	$: cardHeightValue = cardHeight ? cardHeight + "px" : "auto";

</script>

<div
	class="wx-card"
	class:wx-hidden={dragging}
	class:wx-selected={selected}
	class:wx-dimmed={meta?.dimmed}
	data-drag-item={cardFields.id}
	style="height:{cardHeightValue};max-height:{cardHeightValue};">
	<svelte:component
		this={cardTemplate}
		{cardFields}
		{dragging}
		{selected}
		{cardShape}
		on:action />
</div>

<style>
	.wx-card {
		box-sizing: border-box;

		background: var(--wx-kanban-card-background);
		border: var(--wx-kanban-card-border);
		border-radius: var(--wx-kanban-card-border-radius);

		width: 100%;
		min-height: 70px;
		margin: 10px 0;

		position: relative;
		font-size: 14px;

		display: flex;
		flex-direction: column;
	}
	.wx-dimmed {
		opacity: 0.2;
	}
	.wx-hidden {
		display: none;
	}

	.wx-selected {
		border: 1px solid var(--wx-color-primary);
	}

</style>
